import clsx from 'clsx';
import { ReactNode } from 'react';

import css from './Styles.module.scss';

type AdRowProps = {
  children: ReactNode;
  alignment: 'left' | 'right' | 'center';
};

export const Row: React.FC<AdRowProps> = ({ children, alignment }) =>
{
  return (
    <div className={clsx([css.row, css.fullRow, css[alignment]])}>
        {children}
    </div>
  );
};

export const InlineRow: React.FC<AdRowProps> = ({ children, alignment }) =>
{

  return (
    <div className={clsx([css.row, css.inline, css[alignment]])}>
        {children}
    </div>
  );
};